import Fetch, { V1, V2, V3, V4 } from 'Util/fetcher';

//= =================================//
//          VALIDATE PIN            //
//= =================================//

const ON_VALIDATE_PIN = 'ON_VALIDATE_PIN';
const ON_VALIDATE_PIN_SUCCESS = 'ON_VALIDATE_PIN_SUCCESS';
const ON_VALIDATE_PIN_FAILURE = 'ON_VALIDATE_PIN_FAILURE';
const ON_PIN_LOADING = 'ON_PIN_LOADING';
// const ON_REDIRECT_TO = 'ON_REDIRECT_TO';

function onValidatePin() {
  return {
    type: ON_VALIDATE_PIN,
  };
}

function onValidatePinSuccess(payload) {
  return {
    type: ON_VALIDATE_PIN_SUCCESS,
    payload,
  };
}

function onValidatePinFailure(payload) {
  return {
    type: ON_VALIDATE_PIN_FAILURE,
    payload,
  };
}

export const onSetPinLoading = (payload) => ({
  type: ON_PIN_LOADING,
  payload,
});

// export const onRedirectTo = (payload) => ({
//   type: ON_REDIRECT_TO,
//   payload,
// });

export const onDoValidatePin = (payload) => (dispatch) => {
  dispatch(onValidatePin());
  Fetch.post(`${V4}users/me/pin/validate/`, payload, false, true)
    .then((resp) => {
      if (resp.json.result.valid === true) {
        dispatch(onValidatePinSuccess(resp.json));
      } else {
        dispatch(onValidatePinFailure(resp.json.err_message));
      }
    })
    .catch((error) => {
      dispatch(onValidatePinFailure(error.message));
    });
};

//= =================================//
//            CREATE PIN            //
//= =================================//

const ON_CREATE_PIN = 'ON_CREATE_PIN';
const ON_CREATE_PIN_SUCCESS = 'ON_CREATE_PIN_SUCCESS';
const ON_CREATE_PIN_FAILURE = 'ON_CREATE_PIN_FAILURE';

function onCreatePin() {
  return {
    type: ON_CREATE_PIN,
  };
}

function onCreatePinSuccess(payload) {
  return {
    type: ON_CREATE_PIN_SUCCESS,
    payload,
  };
}

function onCreatePinFailure(payload) {
  return {
    type: ON_CREATE_PIN_FAILURE,
    payload,
  };
}

export const onDoCreatePin = (payload, is6Digit) => (dispatch) => {
  let endpoint = '';

  if (is6Digit) {
    endpoint = `${V3}users/me/pin/create/`;
  } else {
    endpoint = `${V2}users/me/pin/create/`;
  }

  dispatch(onCreatePin());
  Fetch.post(endpoint, payload, false, true)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onCreatePinSuccess(resp.json));
      } else {
        dispatch(onCreatePinFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onCreatePinFailure(error.message));
    });
};

//= =================================//
//            RESET PIN             //
//= =================================//

const ON_RESET_PIN = 'ON_RESET_PIN';

function onResetPin(payload) {
  return {
    type: ON_RESET_PIN,
    payload,
  };
}

export const onDoResetPin = () => (dispatch) => {
  dispatch(onResetPin());
};

//= =================================//
//            UPDATE PIN             //
//= =================================//

const ON_UPDATE_PIN = 'ON_UPDATE_PIN';
const ON_UPDATE_PIN_SUCCESS = 'ON_UPDATE_PIN_SUCCESS';
const ON_UPDATE_PIN_FAILURE = 'ON_UPDATE_PIN_FAILURE';
const ON_FORGOT_PIN = 'ON_FORGOT_PIN';
const ON_FORGOT_PIN_SUCCESS = 'ON_FORGOT_PIN_SUCCESS';
const ON_FORGOT_PIN_FAILURE = 'ON_FORGOT_PIN_FAILURE';

function onUpdatePin() {
  return {
    type: ON_UPDATE_PIN,
  };
}

function onUpdatePinSuccess(payload) {
  return {
    type: ON_UPDATE_PIN_SUCCESS,
    payload,
  };
}

function onUpdatePinFailure(payload) {
  return {
    type: ON_UPDATE_PIN_FAILURE,
    payload,
  };
}

function onForgotPin() {
  return {
    type: ON_FORGOT_PIN,
  };
}

function onForgotPinSuccess(payload) {
  return {
    type: ON_FORGOT_PIN_SUCCESS,
    payload,
  };
}

function onForgotPinFailure(payload) {
  return {
    type: ON_FORGOT_PIN_FAILURE,
    payload,
  };
}

export const onDoRequestUpdatePin = (payload) => (dispatch) => {
  dispatch(onUpdatePin());
  Fetch.post(`${V1}users/me/pin/update/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onUpdatePinSuccess(resp.json));
      } else {
        dispatch(onUpdatePinFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onUpdatePinFailure(error.message));
    });
};

export const onDoRequestForgotPin =
  (payload, version = V4) =>
  (dispatch) => {
    dispatch(onForgotPin());
    Fetch.post(`${version}users/me/pin/forget/`, payload)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onForgotPinSuccess(resp.json));
        } else {
          dispatch(onForgotPinFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onForgotPinFailure(error.message));
      });
  };

//= ===========================================================//

const INITIAL_STATE = {
  validatePinLoading: null,
  validatePinSuccess: null,
  validatePinError: null,

  createPinLoading: null,
  createPinSuccess: null,
  createPinError: null,

  updatePinLoading: false,
  updatePinSuccess: null,
  updatePinError: null,
  pinLoading: true,
  // redirectTo: null,
  pinToken: null,
};

const pin = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case ON_VALIDATE_PIN:
      return {
        ...state,
        validatePinLoading: true,
        validatePinSuccess: null,
        validatePinError: null,
      };
    case ON_VALIDATE_PIN_SUCCESS:
      return {
        ...state,
        validatePinLoading: false,
        validatePinSuccess: action.payload,
        pinToken: action.payload?.result?.pin_token,
        validatePinError: null,
      };
    case ON_VALIDATE_PIN_FAILURE:
      return {
        ...state,
        validatePinLoading: false,
        validatePinSuccess: null,
        pinToken: null,
        validatePinError: action.payload,
      };
    case ON_RESET_PIN:
      return {
        ...state,
        validatePinLoading: null,
        validatePinSuccess: null,
        validatePinError: null,
      };
    case ON_CREATE_PIN:
      return {
        ...state,
        createPinLoading: true,
        createPinSuccess: null,
        createPinError: null,
      };
    case ON_CREATE_PIN_SUCCESS:
      return {
        ...state,
        createPinLoading: false,
        createPinSuccess: action.payload,
        createPinError: null,
      };
    case ON_CREATE_PIN_FAILURE:
      return {
        ...state,
        createPinLoading: false,
        createPinSuccess: null,
        createPinError: action.payload,
      };
    case ON_UPDATE_PIN:
      return {
        ...state,
        updatePinLoading: true,
        updatePinError: null,
        updatePinSuccess: null,
      };
    case ON_UPDATE_PIN_SUCCESS:
      return {
        ...state,
        updatePinLoading: false,
        updatePinError: null,
        updatePinSuccess: action.payload,
      };
    case ON_UPDATE_PIN_FAILURE:
      return {
        ...state,
        updatePinLoading: false,
        updatePinError: action.payload,
        updatePinSuccess: null,
      };
    case ON_FORGOT_PIN:
      return {
        ...state,
        forgotPinLoading: true,
        forgotPinError: null,
        forgotPinSuccess: null,
      };
    case ON_FORGOT_PIN_SUCCESS:
      return {
        ...state,
        forgotPinLoading: false,
        forgotPinError: null,
        forgotPinSuccess: action.payload,
      };
    case ON_FORGOT_PIN_FAILURE:
      return {
        ...state,
        forgotPinLoading: false,
        forgotPinError: action.payload,
        forgotPinSuccess: null,
      };
    case ON_PIN_LOADING:
      return {
        ...state,
        pinLoading: action.payload,
      };
    // case ON_REDIRECT_TO:
    //   return {
    //     ...state,
    //     redirectTo: action.payload,
    //   };
    default:
      return state;
  }
};

export default pin;
